import { defaultLocale, supportedLocales } from '@/shared/i18n/config';
import type { PageModule, RouteDefinition } from '@/shared/navigation/types';

const routeModules = import.meta.glob<PageModule>('../../routes/**/*.tsx');
const ignoredPages = new Set(['_app', '_document', '404', '500']);

function fileToRoute(file: string, importPage: () => Promise<PageModule>): RouteDefinition | null {
	const relative = file.match(/routes\/(.+)\.tsx$/)?.[1];
	if (!relative || ignoredPages.has(relative) || relative.startsWith('api/')) return null;

	const routeFile = relative.endsWith('/index') ? relative.slice(0, -'/index'.length) : relative;
	const routePattern = routeFile === 'index' || routeFile === '' ? '/' : `/${routeFile}`;
	let splatParam: string | undefined;

	const reactSegments = routePattern
		.split('/')
		.map((segment) => {
			const optionalCatchAll = segment.match(/^\[\[\.\.\.(.+)\]\]$/);
			if (optionalCatchAll) {
				splatParam = optionalCatchAll[1];
				return '*';
			}

			const catchAll = segment.match(/^\[\.\.\.(.+)\]$/);
			if (catchAll) {
				splatParam = catchAll[1];
				return '*';
			}

			const parameter = segment.match(/^\[(.+)\]$/);
			return parameter ? `:${parameter[1]}` : segment;
		})
		.join('/');

	return {
		file,
		importPage,
		routePattern,
		reactPath: reactSegments || '/',
		splatParam
	};
}

export const applicationRoutes = Object.entries(routeModules)
	.map(([file, importPage]) => fileToRoute(file, importPage))
	.filter((route): route is RouteDefinition => route !== null);

export const notFoundPage = routeModules['../../routes/404.tsx'];
export const errorPage = routeModules['../../routes/500.tsx'];

export { defaultLocale, supportedLocales };
